// WO-34: a store listing's photo of the product, hotlinked from the store's Shopify CDN (never copied to our server),
// at the width the slot needs (Shopify resizes on its own CDN). Only Shopify CDN URLs are resized.
export function photoAt(url, width) {
  try {
    const u = new URL(url);
    if (u.hostname !== 'cdn.shopify.com' && !u.pathname.startsWith('/cdn/shop/')) return url;
    u.searchParams.set('width', String(width));
    return u.toString();
  } catch (e) {
    return url;
  }
}

// WO-35 round 3b: per-photo hints computed by the WO-34 photo job from its thumbnail (absent when not computed):
// bg "white" | "light" | "dark" | "busy" (border pixels), inner_white 0..1 (near-pure white inside the product, not
// connected to the border), aspect (w/h). Product rows carry them as photo_bg / photo_inner_white / photo_aspect;
// set cover_photo and series cover_photos items as bg / inner_white / aspect.
export function photoHintsOf(obj, { prefixed = true } = {}) {
  if (!obj) return null;
  const k = (name) => (prefixed ? `photo_${name}` : name);
  const hints = { bg: obj[k('bg')], innerWhite: obj[k('inner_white')], aspect: obj[k('aspect')] };
  return hints.bg === undefined && hints.innerWhite === undefined && hints.aspect === undefined ? null : hints;
}

// Above this share of white inside the product, keying out white would punch holes in the product (g1.etb 0.142).
export const INNER_WHITE_MAX = 0.03;

// How a store photo is drawn on the dark UI:
//  'keyout' - studio white (or no hints yet): white keyed out, the product on the dark spotlight;
//  'glow'   - white background but lots of white print inside (keying out would punch holes), or an off-white
//             ("light") background below the key-out threshold: multiplied onto a light spotlight that fades to the
//             dark tile, so the background melts into the glow and white print stays white;
//  'plain'  - a photo on a real or dark background, or a product cut tight to the frame ("busy", "dark"): shown whole.
export function photoMode(hints) {
  if (!hints || hints.bg === undefined) {
    return hints && Number(hints.innerWhite) > INNER_WHITE_MAX ? 'glow' : 'keyout';
  }
  if (hints.bg === 'white') return Number(hints.innerWhite) > INNER_WHITE_MAX ? 'glow' : 'keyout';
  if (hints.bg === 'light') return 'glow';
  return 'plain';
}

export const shouldKeyOutWhite = (hints) => photoMode(hints) === 'keyout';
